// @core/api/endpoints/booking/confirm_booking.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingLifecycleResponse,
  ConfirmBookingRequest,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Confirm booking
 * Provider confirms a pending booking. Works for any entity with BookingAspect (TrainerSession, CarTrip, standalone Booking, etc.). Blocks the time slot, notifies the customer, and optionally triggers deposit charge.
 */
export async function ConfirmBooking(
  target_type: string,
  target_id: string,
  data: ConfirmBookingRequest,
  options?: RequestOptions
): Promise<BookingLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking/:target_type/:target_id/confirm`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<BookingLifecycleResponse>(requestPath, data, requestOptions);
}
